import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateAlarmPolicyDeploymentAPI = async (
  deviceId,
  addNewAlarmPolicyIds,
  deleteExistAlarmPolicyIds,
  t,
  successfulText
) => {
  await axios({
    url: `/api/v2/alarm/deploy/update-device-alarm-policies`,
    method: "PUT",
    data: {
      device_id: deviceId,
      add_new_alarm_policy_ids: addNewAlarmPolicyIds
        ? addNewAlarmPolicyIds
        : null,
      delete_exist_alarm_policy_ids: deleteExistAlarmPolicyIds
        ? deleteExistAlarmPolicyIds
        : null
    }
  });
  successHandling(t, successfulText);
  return true;
};
